import { isNetworkFailure } from 'api/agentSessions/projectSuggestions.api';

/**
 * The backend answers `{ errors: { message, fields? } }`; makeRequest keeps
 * that body on `error.response` and uses the HTTP status text as `message`.
 * Prefer the field message, then the envelope message, then the status text.
 */
export function assignErrorMessage(e: unknown, subject = 'Project'): string {
  // The browser's own wording ("Failed to fetch", "Load failed") reads like a bug.
  if (isNetworkFailure(e)) return 'You’re offline. Check your connection and try again.';
  const response = (
    e as { response?: { errors?: { message?: string; fields?: Record<string, string[]> } } }
  ).response;
  const field = response?.errors?.fields && Object.values(response.errors.fields).flat()[0];
  if (field) return `${subject} ${field}`;
  return response?.errors?.message || (e as Error).message || 'Could not update the project';
}
